import { render, staticRenderFns } from "./ScenarioTemplatesChangeInfo.vue?vue&type=template&id=9c23de3e&scoped=true&"
import script from "./ScenarioTemplatesChangeInfo.vue?vue&type=script&lang=js&"
export * from "./ScenarioTemplatesChangeInfo.vue?vue&type=script&lang=js&"
import style0 from "../../Style/scenario-change-info.scss?vue&type=style&index=0&id=9c23de3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c23de3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c23de3e')) {
      api.createRecord('9c23de3e', component.options)
    } else {
      api.reload('9c23de3e', component.options)
    }
    module.hot.accept("./ScenarioTemplatesChangeInfo.vue?vue&type=template&id=9c23de3e&scoped=true&", function () {
      api.rerender('9c23de3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/Templates/ScenarioTemplatesChangeInfo.vue"
export default component.exports